module.exports = __webpack_public_path__ + "static/img/BY-S07.ce9f238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY_S07/BY-S07.png
// module id = 2Rzo
// module chunks = 0